export const VUE_APP_I18N_LOCALE = 'ru';
export const API_URL = 'https://api.capusta.space/v1/pp/';
export const API_CABINET = 'https://api.capusta.space/v1/cabinet/';
export const DOCS_URL = 'https://docs.capusta.space/';
export const DOMAIN_TITLE = 'Capusta.space';
export const EXTERNAL_CHECKOUT_SHOP_ID = '817314';
export const MERCHANT_ID = 'aca72e2b-07d2-4c43-b7e9-42be4cc84db3';

export const CRYPTO_SOCKET_URL = 'wss://api.capusta.space/crypto';
